module.exports = "pegasus/assets/themelp1/small/23.png";